(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[593],{

/***/ 4987:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping-policy",
      function () {
        return __webpack_require__(5982);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_pages_shipping_policy_index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9407);
/* harmony import */ var _styles_pages_shipping_policy_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_shipping_policy_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



// @ts-ignore
function ShippingPolicy(param) {
    let { shippingPolicy  } = param;
    /**
     * The page contain about the product shipping policy
     * The text are managed via 3 different styles and one for list.
     */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_pages_shipping_policy_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().banner),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "title-text",
                    children: "shipping policy"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_pages_shipping_policy_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
                dangerouslySetInnerHTML: {
                    __html: shippingPolicy
                }
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShippingPolicy);


/***/ }),

/***/ 9407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","banner":"shipping-policy_banner__MrAj_","container":"shipping-policy_container__Fu5li","about-image-in":"shipping-policy_about-image-in__fhig_","fade-in-honeycomb":"shipping-policy_fade-in-honeycomb__rgpTq","dot-falling":"shipping-policy_dot-falling__1heKB","dot-falling-before":"shipping-policy_dot-falling-before__Fv18J","dot-falling-after":"shipping-policy_dot-falling-after__QLgvV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(4987); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);